(function () {
  function messageFor(root, key, fallback) {
    var attr = root.getAttribute("data-es-crm-msg-" + key);
    return attr && attr.trim() ? attr : fallback;
  }

  function showError(errorEl, text) {
    if (!errorEl) return;
    errorEl.textContent = text;
    errorEl.hidden = false;
  }

  function initForm(root) {
    if (!root || root.dataset.esCrmBound === "1") return;
    root.dataset.esCrmBound = "1";

    var form = root.querySelector("form");
    var successEl = root.querySelector("[data-es-crm-success]");
    var errorEl = root.querySelector("[data-es-crm-error]");
    if (!form) return;

    form.addEventListener("submit", function (event) {
      event.preventDefault();
      if (errorEl) errorEl.hidden = true;
      if (successEl) successEl.hidden = true;

      var formData = new FormData(form);
      var formType = root.getAttribute("data-es-crm-form-type") || "general";
      var email = String(formData.get("email") || "").trim();
      var phone = String(formData.get("phone") || "").trim();
      var privacy = formData.get("privacy_consent") === "on";
      var phoneInput = form.querySelector('input[name="phone"]');
      var hireType = String(formData.get("type_of_hire") || "").trim();
      var hireLocation = String(formData.get("hire_location") || "").trim();

      if (!email) {
        showError(errorEl, messageFor(root, "email", "Please enter your email address."));
        return;
      }

      if (phoneInput && phoneInput.required && !phone) {
        showError(errorEl, messageFor(root, "phone", "Please enter your phone number."));
        return;
      }

      if (formType === "hire") {
        var hireTypeInput = form.querySelector('[name="type_of_hire"]');
        if (hireTypeInput && hireTypeInput.required && !hireType) {
          showError(
            errorEl,
            messageFor(root, "hire-type", "Please select a hire type."),
          );
          return;
        }
        var locationInput = form.querySelector('[name="hire_location"]');
        if (locationInput && locationInput.required && !hireLocation) {
          showError(
            errorEl,
            messageFor(root, "location", "Please enter a hire location."),
          );
          return;
        }
      }

      if (!privacy) {
        showError(
          errorEl,
          messageFor(root, "privacy", "Please agree to the privacy consent to continue."),
        );
        return;
      }

      var payload = {
        email: email,
        first_name: String(formData.get("first_name") || "").trim() || undefined,
        last_name: String(formData.get("last_name") || "").trim() || undefined,
        phone: phone || undefined,
        message: String(formData.get("message") || "").trim() || undefined,
        marketing_opt_in: formData.get("marketing_opt_in") === "on",
        fields: {
          form_type: formType,
          privacy_consent: true,
        },
      };

      root.querySelectorAll("[data-es-crm-field]").forEach(function (input) {
        var key = input.getAttribute("data-es-crm-field");
        if (!key) return;
        var value = "value" in input ? input.value : "";
        if (String(value).trim()) payload.fields[key] = String(value).trim();
      });

      if (window.esCrmAttribution && window.esCrmAttribution.applyToFormPayload) {
        payload = window.esCrmAttribution.applyToFormPayload(payload);
      }

      var submitBtn = form.querySelector("[type=submit]");
      if (submitBtn) submitBtn.disabled = true;

      fetch("/apps/es-crm/form", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(payload),
      })
        .then(function (res) {
          return res.json().then(function (body) {
            if (!res.ok) {
              var err =
                typeof body.error === "string"
                  ? body.error
                  : messageFor(root, "generic", "Something went wrong. Please try again.");
              throw new Error(err);
            }
            return body;
          });
        })
        .then(function () {
          form.reset();
          if (successEl) successEl.hidden = false;
        })
        .catch(function (err) {
          showError(
            errorEl,
            err && err.message
              ? err.message
              : messageFor(root, "generic", "Something went wrong. Please try again."),
          );
        })
        .finally(function () {
          if (submitBtn) submitBtn.disabled = false;
        });
    });
  }

  function initAll() {
    document.querySelectorAll("[data-es-crm-form]").forEach(initForm);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", initAll);
})();
